'use client';

import { Pagination } from '@/app_components/common/Pagination';
import { PressReleaseCard } from '@/app_components/EzNewswire/PressReleaseCard';
import { ContentPlacement } from '@/app_lib/types/analytics';
import type { Pagination as PaginationInterface, PressReleaseListEntity } from '@/app_lib/types/EzNewswireApiEntities';

interface PressReleaseListProps {
  list: PressReleaseListEntity[];
  pagination: PaginationInterface;
}

export const PressReleaseList = ({ list, pagination }: PressReleaseListProps) => {
  return (
    <div className='flex flex-col gap-10 md:gap-6 lg:gap-10'>
      <div
        className='flex flex-col gap-6'
        data-cy={ContentPlacement.EzNewswirePressReleasesList}
      >
        {list.map((card) => (
          <PressReleaseCard
            date={card.publishDate}
            excerpt={card.excerpt || ''}
            headline={card.title}
            key={card.slug}
            location={card.location}
            thumbnail={card.image?.url || ''}
            url={card.slug}
          />
        ))}
      </div>
      <div
        className='flex justify-center w-full'
        data-cy={ContentPlacement.EzNewswireListPagination}
      >
        <Pagination
          currentPage={pagination.currentPage}
          href='/press-releases'
          onPageChange={() => {}}
          removePageOnFirst
          totalPages={pagination.totalPages}
        />
      </div>
    </div>
  );
};
